export default[
  {
    path: '/dataList/staffSubsidy',
    component: resolve => require(['../index.vue'], resolve),
    meta: {
        title: '店员补贴',
        authLogin: true
    }
  },
  {
    path: '/dataList/equities',
    component: resolve => require(['../staffEquities.vue'], resolve),
    meta: {
        title: '店员权益',
        authLogin: true
    }
  },
  {
    path: '/dataList/subsidy',
    component: resolve => require(['../page.vue'], resolve),
    meta: {
        title: '店员补贴',
        authLogin: true
    }
  }
]